module.exports = __webpack_public_path__ + "mstile-310x310.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon/mstile-310x310.png
// module id = 22
// module chunks = 0